<div #wrapper>
  <ng-content></ng-content>
</div>
